<script lang="ts">
import { Container, Row, Col } from "sveltestrap";
</script>

<section>
  <p class="background-big-letter">About</p>
  <Container>
    <Row>
      <Col xs="9">
        <h2>About the Bike Data Project</h2>
        <p>
          <strong>
            With the Bike Data Project, Open Knowledge Belgium – the umbrella
            organisation for open knowledge and open data initiatives in Belgium
            – wants to build a community-driven open bike data platform that
            collects data on where and when people actually cycle. The project
            aims at aggregating data from cyclists, coming from different mobile
            applications and sources, into one open bike data platform. The
            collective open data will empower local communities in making
            cycling more visible and decision-makers in making cities more
            liveable and bike-friendly.
          </strong>
        </p>

        <div>
          <h3>
            Short history: who's behind the project
          </h3>
          <p>
            The Bike Data Project was initially set up by <a
              href="https://www.wgfilm.com"
              target="_blank"
              rel="noopener noreferrer">WG film</a>
            and launched as part of the release of the
            <a
              href="https://vimeo.com/ondemand/bikesvscars"
              target="_blank"
              rel="noopener noreferrer">Bikes vs Cars documentary</a
            >, directed by Fredrik Gertten. As the documentary has been screened
            in over 50 countries, there has already been collected more than
            275.000 bicycle rides collected.
          </p>
          <p>
            At the beginning of 2020, the project was moved under the umbrella
            of Open Knowledge Belgium. <a
              href="https://be.okfn.org/"
              target="_blank"
              rel="noopener noreferrer">Open Knowledge Belgium</a> (non-profit/vzw/asbl),
            as local chapter of Open Knowledge International, is an umbrella organisation
            for various open knowledge and open data initiatives in Belgium. We strive
            for a world where knowledge creates power for the many, not the few and
            proactively promote openness through projects and events, to the general
            public as well as to experts in the field. As grassroots organisation
            we consist of people, mainly volunteers, passionate about openness, using
            advocacy, research, technology and projects to unlock information, enabling
            people to use and share knowledge.
          </p>
          <p>
            Open Knowledge Belgium guarantees the openness of the project for
            all purposes and takes all required measures according to the GDPR
            regulations concerning data privacy and protection. With a
            transparent and clear terms of use for this project, Open Knowledge
            Belgium wants to set an example on how to deal with privacy-related
            issues and wants to take the opportunity to inform citizens about
            their digital rights.
          </p>
          <h3>
            More cycling data means more power to and for cyclists
          </h3>
          <p>
            Little is known about how cyclists move around in cities today. If
            there’s data available, it’s closed and restricted data sold by one
            single app provider or static data collected through manual counts.
            If we want to have more people cycling in cities and make the
            bicycle as easy and logical to opt for as the car, we also need to
            get the same data insights into cyclists’ behavior as we have about
            car transport.
          </p>
          <p>
            Open Knowledge Belgium aims to create impact by showing where and
            when people actually cycle. The Bike Data Project provides the
            opportunity to collect all cycling data from different applications
            into one platform, which is - based on the principle of open source
            and open data - adaptable and accessible by everyone to ensure it
            benefits society.
          </p>
          <h3>
            Public digital infrastructure as common good
          </h3>
          <p>
            Similar to activities like OpenStreetMap Belgium and Open Planner
            Team by Open Knowledge Belgium, the Bike Data Project is set up as a
            collaborative project which is open to all and makes society benefit
            as a whole. Therefore, the digital infrastructure and aggregated
            data are - based on the principles of open source and open data -
            freely adaptable and accessible to anyone.
          </p>
          <p>
            Furthermore, Open Knowledge Belgium strives to play with this Bike
            Data Project an important role in wider societal movements:
          </p>
          <ul>
            <li>
              <span>Citizens can take back control of their data</span> thanks to
              strong European GDPR regulations. In the case of the Bike Data Project,
              we want to encourage citizens to get their data out of third party
              apps (e.g. popular apps as Strava and even potentially Google Maps)
              and ask them to contribute them to a good cause.
            </li>
            <li>
              <span
                >Promote skill sharing and encourage learning within the
                community</span> throughout the whole process from project launch
              to further development of the platform. Strongly inspired by the work
              of the School of Data in Riga, we want to involve the cycling community
              in the local Bike Data Project campaigns as from the first day. Throughout
              a series of community events, Open Knowledge Belgium wants to improve
              data literacy.
            </li>
            <li>
              <span>Think globally, act locally.</span> The Bike Data Project platform
              is global and open by default. Although it is possible for cycling
              communities all around the world to contribute to the project, Open
              Knowledge Belgium wants to support local communities with making them
              act on a local level.
            </li>
          </ul>
          <h3>
            Longer-term sustainability of the Bike Data Project
          </h3>
          <p>
            Open Knowledge Belgium partners up with Brussels Mobility to launch,
            as part of its Bike for Brussels program, a first campaign in the
            Brussels-Capital Region. The launch of local crowdsourcing campaigns
            in different cities and the setup of the open data platform are part
            of a longer-term plan for the Bike Data Project. When a
            crowdsourcing campaign in a specific city or region comes to an end,
            the platform will stay online and will be maintained by the open
            source community of Open Knowledge Belgium. Cycling communities in
            other cities will be encouraged to launch a campaign in their cities
            and make use of the platform. Given the interest of different
            stakeholders in the Bike Data Platform, Open Knowledge Belgium has
            already received confirmation from different stakeholders that they
            want to contribute financially to the project so that the server
            costs can get covered. In that way, the project will be sustained
            over the longer term.
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</section>

<style>
section {
  margin-top: 200px;
}
h3 {
    margin-top: 2rem;
    margin-bottom: 2rem;
}
</style>
